import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebMatchTextPunctuation({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;

    const [choices, setChoices] = useState({});
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [selectedKeyPrevious, setSelectedKeyPrevious] = useState(null);

    const [availableChoices, setAvailableChoices] = useState(
        makeArrayRandom(data.choices)
    );

    const [answerBox, setAnswerBox] = useState(data.answerBox);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setChoices({});
        setSelectedChoice(null);
        setSelectedKeyPrevious(null);
        setAvailableChoices(makeArrayRandom(data.choices));
        setAnswerBox(data.answerBox);
    }, [question,
        data.choices,
        data.answerBox,
    ]);

    const handleChoiceClick = (choice) => {
        setSelectedChoice(choice);
        setSelectedKeyPrevious(null);
    };

    const handleChoiceAssign = (index) => {
        if (choices[index] && !selectedChoice) {
            const choice = data.choices.find((c) => c.value === choices[index].value);
            setSelectedChoice(choice);
            setSelectedKeyPrevious(index);
        }

        if (selectedChoice && (selectedChoice?.value !== choices[index]?.value)) {
            let currentChoices = {...choices};
            const previousChoice = choices[index];

            if (previousChoice) {
                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    { ...previousChoice },
                ]);
            }

            // we will check here if coming from previous answer
            if (selectedKeyPrevious !== null) {
                delete currentChoices[selectedKeyPrevious];
                setSelectedKeyPrevious(null);
            }
            // updating answer
            currentChoices = {
                ...currentChoices,
                [index]: {
                    value: selectedChoice.value,
                },
            }
            setChoices(currentChoices);

            if (
                typeof questionData.answer.value === "object" &&
                !Array.isArray(questionData.answer.value)
            ) {
                const answerKeys = Object.keys(questionData.answer.value);

                const formattedAnswer = answerKeys.reduce(
                    (acc, key, keyIndex) => {
                        acc[key] = currentChoices[key]?.value || null;
                        return acc;
                    },
                    {}
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: formattedAnswer,
                });
            } else {
                const updatedAnswer = Object.values(currentChoices).map(
                    (choice) => choice.value
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: updatedAnswer,
                });
            }

            setAvailableChoices((prevChoices) =>
                prevChoices.filter(
                    (item) => item.value !== selectedChoice.value
                )
            );

            setSelectedChoice(null);
        }
    };

    const handleRemoveChoice = (index) => {
        const removedChoice = choices[index];
        
        if (removedChoice) {
            setChoices((prevChoices) => {
                const newChoices = { ...prevChoices };
                delete newChoices[index];

                if (
                    typeof questionData.answer.value === "object" &&
                    !Array.isArray(questionData.answer.value)
                ) {
                    const answerKeys = Object.keys(
                        questionData.answer.value
                    );

                    let canProceed = false;
                    const formattedAnswer = answerKeys.reduce(
                        (acc, key, keyIndex) => {
                            acc[key] = newChoices[key]?.value || null;
                            if (acc[key] !== null && acc[key] !== "") {
                                canProceed = true;
                            }
                            return acc;
                        },
                        {}
                    );

                    onAnswer({
                        canProceed,
                        answer: formattedAnswer,
                    });
                } else {
                    const updatedAnswer = Object.values(newChoices).map(
                        (choice) => choice.value
                    );

                    // set to false so that next button will be disabled
                    const canProceed = false;
                    onAnswer({
                        canProceed,
                        answer: updatedAnswer,
                    });
                }

                return newChoices;
            });

            setAvailableChoices((prevChoices) => [
                ...prevChoices,
                {
                    value: removedChoice.value,
                },
            ]);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                position: "relative",
                textAlign: "center"
            }}
        >
            {/* For Answer */}
            <Box sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "5px 15px",
                fontWeight: "bold",
                fontSize: "55px",
                width: "800px",
                textAlign: "center",
            }}>
                {answerBox.map((answer, index) => (
                    <Box key={index}
                        sx={{
                            display: "inline-block",
                            backgroundColor: "rgb(122, 140, 142)",
                            borderBottom: "5px solid rgb(91, 105, 107)",
                            padding: "10px 10px 10px",
                            fontWeight: "bold",
                            fontSize: "55px",
                            textAlign: "center",
                            height: "289px",
                        }}
                    >
                        <Box sx={{
                            backgroundColor: "rgb(242, 242, 242)",
                            height: "175px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            fontSize: "55px",
                            textAlign: "center",
                        }}>
                            {answer.children.map((row, rowIndex) => {
                                const Tag = row.type;
                                return (
                                    <Tag style={row.style} key={rowIndex}>{row.value}</Tag>
                                )
                            })}
                        </Box>
                        <Box 
                            sx={{
                                height: "75px",
                                width: "200px",
                                marginTop: "10px",
                                position: "relative",
                                display: "inline-block",
                                boxSizing: "border-box",
                                padding: "4px",
                                lineHeight: "0.8em",
                                fontWeight: "bold",
                                fontSize: "20px",
                                textAlign: "center",
                                boxShadow:
                                    selectedChoice
                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                        : "none",
                                backgroundColor: choices[answer.stateKey]
                                        ? "#aad6e7"
                                        : "white",
                                borderTop: choices[answer.stateKey]
                                        ? "none"
                                        : "10px solid rgb(91, 105, 106)",
                            }}
                            onClick={() => handleChoiceAssign(answer.stateKey)}
                        >
                        {choices[answer.stateKey] ? (
                            <Box
                                sx={{
                                    top: "initial",
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    lineHeight: "0.8em",
                                    fontWeight: "bold",
                                    fontSize: "55px",
                                    textAlign: "center"
                                }}
                            >
                                <Box sx={{
                                    position: "relative",
                                    lineHeight: "1em",
                                    fontWeight: "bold",
                                    fontSize: "20px",
                                    height: "67px",
                                    width: "192px",
                                    display: "inline-block",
                                    boxSizing: "content-box",
                                    backgroundColor: "#aad6e7",
                                    padding: "4px",
                                    textAlign: "center",
                                }}>
                                    <Box sx={{
                                        display: "inline-flex",
                                        width: "100%",
                                        height: "100%",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        userSelect: "none",
                                        pointerEvents: "none",
                                        fontSize: "18px",
                                        lineHeight: "1em",
                                        fontWeight: "bold",
                                        textAlign: "center"
                                    }}>{choices[answer.stateKey].value}</Box>
                                </Box>
                                {/* Close  */}
                                <Box 
                                    className="selected-close-btn"
                                    sx={{
                                        right: "0px",
                                        top: "0px",
                                        display: "content-box",
                                        lineHeight: "0.8em",
                                        fontWeight: "bold",
                                        fontSize: "20px",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveChoice(answer.stateKey);
                                    }}
                                >X</Box>
                            </Box>
                                ) :
                                <Box component="span"></Box>
                            }
                        </Box>
                    </Box>
                ))}
            </Box>
            
            {/* For Choices */}
            <Box sx={{
                position: "relative",
                width: "225px",
                marginLeft: "10px",
                border: "1px dashed lightgrey",
                textAlign: "center",
            }}>
                <Box sx={{
                    boxSizing: "border-box",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 10px",
                    position: "absolute",
                    top: "0",
                    left: "0",
                    textAlign: "center",
                }}>
                    {availableChoices.map((choice, index) => (
                        <Box key={index}
                            sx={{
                                borderBottom: "10px solid rgb(52, 148, 186)",
                                position: "relative",
                                lineHeight: "1em",
                                fontWeight: "bold",
                                fontSize: "20px",
                                height: "67px",
                                width: "192px",
                                display: "inline-block",
                                boxSizing: "content-box",
                                backgroundColor: "#aad6e7",
                                padding: "4px",
                                textAlign: "center",
                                boxShadow:
                                        selectedChoice?.value === choice.value
                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                            : "none",
                            }}
                            onClick={() => { handleChoiceClick(choice) }}
                            disabled={selectedChoice === choice}
                        >
                            <Box sx={{
                                display: "inline-flex",
                                width: "100%",
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                                userSelect: "none",
                                pointerEvents: "none",
                                fontSize: "18px",
                                lineHeight: "1em",
                                fontWeight: "bold",
                                textAlign: "center"
                            }}>{choice.value}</Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};